const useItems = (activeSectionsWithData) => {
    const items = [];
    activeSectionsWithData?.forEach((config) => {
        if (config?.data) {
            items.push(...config.data);
        }
    });
    return items;
};
export default useItems;
